/**
 * Whether the given dialer input is a dialable phone number.
 *
 * The dialer input is dual-purpose: free text searches agents/contacts by
 * name, while a numeric value can be dialed directly. A value is dialable when
 * it contains at least one digit and consists only of digits and common phone
 * separators (optional leading `+`, spaces, dashes, dots, parentheses).
 * Non-numeric search text (e.g. "test") is therefore rejected.
 *
 * Examples:
 *  - `"1010"` → true
 *  - `"+90 532 123 45 67"` → true
 *  - `"(212) 555-0123"` → true
 *  - `"test"` → false
 *  - `""` → false
 */
export function isDialablePhoneNumber(value: string): boolean {
  const trimmed = value.trim();
  if (!trimmed) {
    return false;
  }

  return /^\+?[0-9\s\-().]*[0-9][0-9\s\-().]*$/.test(trimmed);
}
